import { css } from '@emotion/css'
import { colors, spacing, mediaQueryHelper, breakpoint } from '@offerzen/pinata'

const TOOLBAR_HEIGHT = 50

const styles = {
  toolbarWrapper: css({
    backgroundColor: colors.white,
  }),

  toolbar: css({
    padding: 0,
    height: TOOLBAR_HEIGHT,
  }),

  container: css({
    padding: 0,

    [mediaQueryHelper(breakpoint.tablet)]: {
      marginTop: spacing.extraLarge,
      marginBottom: spacing.extraLarge,
    },
  }),
}

export default styles
